import React from 'react';
import BasePage from '../BasePage/BasePage';
import {getDandadSubNavLinks} from './subNavLinks';
import EditorialPageContent from '../EditorialPage/EditorialPageContent/EditorialPageContent';

export const DandadPage = ({editorial}) => {
    const subNavLinks = getDandadSubNavLinks()
    return (
        <BasePage subNavLinks={subNavLinks}>
            <EditorialPageContent pageCategory={"editorial"} editorial={editorial} />
        </BasePage>
    )
}

